import React, { useEffect, useRef } from 'react';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';

interface FileDropzoneProps {
    id?: string;
    onFilesAdded?: (files: File[]) => void;
    maxFileSize?: number; // in MB
    acceptedFiles?: string;
    maxFiles?: number;
    className?: string;
}

const FileDropzone: React.FC<FileDropzoneProps> = ({
    id = `dropzone-${Math.random().toString(36).substr(2, 9)}`,
    onFilesAdded,
    maxFileSize = 6, // 6MB default
    acceptedFiles = '.jpeg,.jpg,.png,.mp4,.mpeg4',
    maxFiles,
    className = ''
}) => {
    const dropzoneRef = useRef<HTMLFormElement>(null);
    const dropzoneInstance = useRef<Dropzone | null>(null);

    useEffect(() => {
        if (dropzoneRef.current && !dropzoneInstance.current) {
            // Disable auto-discover to prevent Dropzone from automatically initializing
            Dropzone.autoDiscover = false;

            dropzoneInstance.current = new Dropzone(dropzoneRef.current, {
                url: '/target', // This can be changed to your upload endpoint
                autoProcessQueue: false, // Don't automatically upload
                maxFilesize: maxFileSize,
                acceptedFiles: acceptedFiles,
                maxFiles: maxFiles,
                addRemoveLinks: true,
                dictDefaultMessage: '',
                init: function (this: Dropzone) {
                    this.on('addedfile', (_file: File) => {
                        if (onFilesAdded) {
                            const files = this.getAcceptedFiles();
                            onFilesAdded(files);
                        }
                    });

                    this.on('removedfile', () => {
                        if (onFilesAdded) {
                            const files = this.getAcceptedFiles();
                            onFilesAdded(files);
                        }
                    });
                }
            });
        }

        // Cleanup
        return () => {
            if (dropzoneInstance.current) {
                dropzoneInstance.current.destroy();
                dropzoneInstance.current = null;
            }
        };
    }, [maxFileSize, acceptedFiles, maxFiles, onFilesAdded]);

    return (
        <form
            ref={dropzoneRef}
            action="/target"
            className={`dropzone mb-2 ${className}`}
            id={id}
        >
            <div className="dz-default dz-message my-2">
                <i className="h1 bi bi-cloud-upload"></i><br />
                <button className="dz-button" type="button">
                    Drag and Drop or Click here to upload
                </button>
            </div>
        </form>
    );
};

export default FileDropzone;
